import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiClient from "utils/apiClient";

const API_BASE_URL = "/olitask-service/api/v1/app-config";

const useAppConfig = () => {
  const authToken = sessionStorage.getItem("authToken");
  const [appConfig, setAppConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAxiosErrors = (err, action = "fetch app config") => {
    let message = "An unexpected error occurred.";
    if (err.response) {
      message =
        err.response.data?.message ||
        `Failed to ${action}: ${err.response.statusText}`;
    } else if (err.request) {
      message =
        "No response from the server. Please check your internet connection.";
    } else {
      message = err.message || "Something went wrong.";
    }
    setError(message);
    toast.error(message);
    console.error(`${action} error:`, err);
  };

  const fetchAppConfig = useCallback(async () => {
    if (!authToken) return;
    setLoading(true);
    setError(null);

    try {
      const res = await apiClient.get(API_BASE_URL);
      setAppConfig(res.data);
    } catch (err) {
      handleAxiosErrors(err, "fetch app config");
    } finally {
      setLoading(false);
    }
  }, [authToken]);

  useEffect(() => {
    fetchAppConfig();
  }, [fetchAppConfig]);

  return {
    appConfig,
    loading,
    error,
    refresh: fetchAppConfig,
  };
};

export default useAppConfig;
